export default __webpack_public_path__ + "static/media/imgLogin.85d64940.jpg";